import { ReactComponent as ThanxAiSparkles } from 'assets/images/thanx-ai-sparkles.svg'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.segment_visualization')

interface CreateAnotherSegmentCTAProps {
  onClick: () => void
}

const CreateAnotherSegmentCTA = ({ onClick }: CreateAnotherSegmentCTAProps) => {
  return (
    <button
      type="button"
      className="thanx-ai-conversation__create-another"
      onClick={onClick}
      aria-label={t('create_another_segment')}
    >
      <span className="thanx-ai-conversation__create-another__label">
        <span
          className="thanx-ai-conversation__create-another__icon"
          aria-hidden="true"
        >
          <ThanxAiSparkles />
        </span>
        {t('create_another_segment')}
      </span>
    </button>
  )
}

export default CreateAnotherSegmentCTA
